<mat-dialog-content fxLayout="column" fxLayoutAlign="center center" class="h-full">
  <div class="text-4xl mb-4 select-none" fxLayout="row" fxLayoutAlign="center center">
    <mat-icon inline>wifi_off</mat-icon>
  </div>
  <span translate>utils.offline</span>
  <button mat-button class="!mt-3" color="primary" (click)="reload()" [disabled]="!(isOnline$ | async)">
    {{ 'utils.reload' | translate }}
  </button>
</mat-dialog-content>
